import React, { useState, useRef } from 'react';

export default function NumericKeyBoard({ open, initialValue = '', onOk, onCancel }) {
  const [value, setValue] = useState(initialValue);
  const isFirstInput = useRef(initialValue === '');

  React.useEffect(() => {
    setValue(initialValue);
    isFirstInput.current = initialValue === '';
  }, [open, initialValue]);

  const handleNumber = (num) => {
    setValue((prev) => {
      if (isFirstInput.current) {
        isFirstInput.current = false;
        return num;
      }
      return prev + num;
    });
  };

  const handleBackspace = () => {
    setValue((prev) => {
      const newValue = prev.slice(0, -1);
      isFirstInput.current = newValue.length === 0;
      return newValue;
    });
  };

  const handleOk = () => { onOk && onOk(value); };
  const handleCancel = () => {
    setValue('');
    isFirstInput.current = true;
    onCancel && onCancel();
  };

  if (!open) {
    return null;
  }

  return (
    <div id="numerickeyboard">
      <div className="nk-modal">
        <input
          className="nk-input"
          type="text"
          value={value}
          readOnly
        />
        <div className="nk-content">
          <div className="nk-pad">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n, i) => (
              <button
                key={i}
                className="nk-button"
                onClick={() => handleNumber(n.toString())}>{n}</button>
            ))}
            <button className="nk-button" onClick={() => handleNumber('0')}>0</button>
            <button className="nk-button nk-backspace" onClick={handleBackspace}><i className="large caret left icon"></i></button>
          </div>
          <div className="nk-actions">
            <button className="nk-cancel" onClick={handleCancel}><i className="large close icon"></i></button>
            <button className="nk-ok" onClick={handleOk}><i className="large check icon"></i></button>
          </div>
        </div>
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// src/components/NumericKeyBoard.jsx